import React, { useState, useEffect, useRef } from "react";
import GlobalNavBar from "../shared/globalNavBar/GlobalNavBar";
import PO from "./pure/PO";
import Footer from "../shared/Footer/Footer";
import withIdleTimer from "../common/WithIdleTimer";
import { Route, Router } from "react-router-dom";
import SearchWrapper from "../components/search/searchWrapper/SearchWrapper";
import OrdersSearch from "../components/search/searchWrapper/orders/OrdersSearch";

function POApp(props) {
  const [renderApp, setRenderApp] = useState(false);
  const [padding, setPaddingState] = useState("70px");

  const userRef = useRef(null);

  if (!userRef.current) {
    userRef.current = new PO(props.userDetails);
  }

  function setPadding(paddingValue) {
    if (paddingValue > 70) {
      setPaddingState(paddingValue + "px");
    }
  }

  useEffect(() => {
    props.history.push(`/`);
    props.i18n.changeLanguage("en");
    setRenderApp(true);
  }, []);

  return (
    renderApp && (
      <Router history={props.history}>
        <div className="appWrapper" id="appWrapper">
          <div style={{ paddingTop: padding }}>
            <GlobalNavBar
              {...props}
              setPadding={setPadding}
              user={userRef.current}
            />
          </div>
          <Route
            exact
            path="/search"
            component={withIdleTimer(() => (
              <SearchWrapper {...props} user={userRef.current} />
            ))}
          />
          <Route
            exact
            path="/search/orders"
            component={withIdleTimer(() => (
              <OrdersSearch
                {...props}
                localizedInfo={props.localizedInfo}
                user={userRef.current}
              />
            ))}
          />
          <Footer permissions={props.userDetails.permissions} />
        </div>
      </Router>
    )
  );
}

export default POApp;
